package com.eladfinish.bible.contest.screens.search.suggestions

/** The three views of the "most searched" list. */
enum class PopularSearchesFilter {
    /** By distinct installations, all time. */
    ALL_TIME,

    /** By distinct installations in the snapshot's recent window. */
    HOT_NOW,

    /** This device's own history, most searched first. */
    MINE,
}

data class PopularSearchesList(
    val filter: PopularSearchesFilter,
    val entries: List<AutocompleteSuggestion>,

    /** The window [PopularSearchesFilter.HOT_NOW] counts over, for its label. */
    val recentDays: Int,
)
